// CRO Address
const BNB_ADDRESS = '0x5C7F8A570d578ED84E63fdFA7b1eE72dEae1AE23'

export { BNB_ADDRESS }
